module.exports = __webpack_public_path__ + "img/gas_blue.1d4573b5.png";